import axios from 'axios'
import Result from "@/utils/serviceResultPattern";

export default {
    createRefund(payload) {
        return axios
            .post('/api/booking/refund/create', payload)
            .then((res) => {
                if (res.status < 200 || res.status >= 300) {
                    return Result.error("We couldn't create the refund at this time. Please try again or contact support if the issue persists.")
                }
                return Result.ok(res.data)
            })
            .catch((error) => {
                return Result.error(error)
            })
    },

    confirmRefund(payload) {
        return axios
            .post('/api/booking/RefundConfirmation', payload)
            .then((res) => {
                if (res.status < 200 || res.status >= 300) {
                    return Result.error("We couldn't confirm the refund at this time. Please try again or contact support if the issue persists.")
                }
                return Result.ok(res.data)
            })
            .catch((error) => {
                return Result.error(error)
            })
    },

    cancelRefund(payload) {
        return axios
            .post('/api/booking/refund/cancel', payload)
            .then((res) => {
                if (res.status < 200 || res.status >= 300) {
                    return Result.error("We couldn't cancel the refund at this time. Please try again or contact support if the issue persists.")
                }
                return Result.ok(res.data)
            })
            .catch((error) => {
                return Result.error(error)
            })
    },
    deleteRefund(id) {
        return axios
            .delete(`/api/booking/refund/${id}/delete`)
            .then((res) => {
                if (res.status < 200 || res.status >= 300) {
                    return Result.error("We couldn't delete the refund at this time. Please try again or contact support if the issue persists.")
                }
                return Result.ok(res.data)
            })
            .catch((error) => {
                return Result.error(error)
            })
    },
}



// WEBPACK FOOTER //
// ./src/api/reservation/refundService.js